import React from "react";
import { Form, Input, Button, message, Icon, Row, Col } from "antd";
import { fetchLogin } from "../../api/login";
import { saveLoginInfo } from "../../utils/token";
import LoginImg from "../../assets/images/login.png";
import Login1 from "../../assets/images/login1.png";
import Logo from "../../assets/images/logo.png";
import { fetchQiniuToken } from "../../api/login";
import {
  Decrypt,
  Encrypt,
  getAESkey,
  showval,
  editAESkey,
  publicKey,
} from "../../utils/secret";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
let encryptor = new JSEncrypt();
var timeId;
const formItemLayout = {
  labelCol: {
    xs: { span: 6 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
};
class Login extends React.Component {
  componentDidMount() {
    clearInterval(timeId);
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let AESkey = showval();
        editAESkey(AESkey);
        encryptor.setPublicKey(publicKey);
        let data = { ...values, aesKey: AESkey };
        let rsaPassWord = encryptor.encrypt(JSON.stringify(data));
        fetchLogin(rsaPassWord).then((res) => {
          if (res.success) {
            timeId = setInterval(() => {
              fetchQiniuToken().then((res) => {
                if (res.success) {
                  sessionStorage.setItem(
                    "loginInfo",
                    JSON.stringify({
                      ...JSON.parse(sessionStorage.getItem("loginInfo")),
                      upToken: res.data,
                    })
                  );
                }
              });
            }, 1000 * 60 * 5);
            let data = JSON.parse(Decrypt(res.data));
            message.success("登录成功");
            saveLoginInfo(data);
            this.props.history.push("/");
          }
        });
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Row style={{ height: "100%" }}>
        <Col style={{ height: "100%", backgroundColor: "#EFEFF1" }} span={12}>
          <img style={{ margin: "42px 0 0 42px" }} src={Logo}></img>
          <img
            src={Login1}
            style={{
              width: 559,
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }}
          ></img>
        </Col>
        <Col style={{ height: "100%", backgroundColor: "#fff" }} span={12}>
          <div
            className="login"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }}
          >
            <div
              style={{
                fontSize: 26,
                color: "rgba(0,0,0,0.85)",
              }}
            >
              奕优科技试试如意运营系统
            </div>
            <div
              style={{
                color: "rgba(0,0,0,0.85)",
                fontSize: 14,
                height: 60,
                lineHeight: "60px",
              }}
            >
              欢迎使用
            </div>
            <Form
              {...formItemLayout}
              onSubmit={this.handleSubmit}
              style={{ width: 338 }}
            >
              <Form.Item className="loginInput">
                {getFieldDecorator("mobilePhone", {
                  rules: [{ required: true, message: "请输入账号" }],
                })(
                  <Input
                    style={{
                      border: "none",
                      borderBottom: "1px solid #ccc",
                      width: 338,
                    }}
                    placeholder="账号"
                  />
                )}
              </Form.Item>
              <Form.Item className="loginInput">
                {getFieldDecorator("password", {
                  rules: [{ required: true, message: "请输入密码" }],
                })(
                  <Input
                    style={{
                      border: "none",
                      borderBottom: "1px solid #ccc",
                      width: 338,
                    }}
                    type="password"
                    placeholder="密码"
                  />
                )}
              </Form.Item>
              <Form.Item>
                <Button
                  style={{
                    height: 50,
                    marginTop: 10,
                    width: 176,
                    marginLeft: 80,
                    borderRadius: 25,
                  }}
                  type="primary"
                  htmlType="submit"
                >
                  登录
                </Button>
              </Form.Item>
            </Form>
          </div>
          <div
            style={{
              position: "absolute",
              width: "100%",
              textAlign: "center",
              bottom: 32,
            }}
          >
            Copyright©️2022上海奕优网络科技有限公司
          </div>
        </Col>
      </Row>
      // <div
      //   style={{
      //     position: "absolute",
      //     top: 0,
      //     left: 0,
      //     right: 0,
      //     bottom: 0,
      //     backgroundImage: `url(${LoginImg})`,
      //     backgroundRepeat: "no-repeat",
      //     backgroundSize: "100% 100%",
      //     display: "flex",
      //     justifyContent: "center",
      //     alignItems: "center"
      //   }}
      // >
      //   <p className="loginWord">再小的商品,也是一笔生意</p>
      //   <div
      //     style={{
      //       width: 500,
      //       padding: "24px 32px",
      //       backgroundColor: "#fff",
      //       position: "absolute",
      //       right: 220
      //     }}
      //   >
      //     <p style={{ fontSize: 20, color: "#353535" }}>登录</p>
      //     <Form
      //       {...formItemLayout}
      //       onSubmit={this.handleSubmit}
      //       style={{ width: 400 }}
      //     >
      //       <Form.Item className="loginInput">
      //         {getFieldDecorator("mobilePhone", {
      //           initialValue: "",
      //           rules: [{ required: true, message: "请输入账号" }]
      //         })(
      //           <Input
      //             prefix={
      //               <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
      //             }
      //             placeholder="请输入账号"
      //           />
      //         )}
      //       </Form.Item>
      //       <Form.Item className="loginInput">
      //         {getFieldDecorator("password", {
      //           initialValue: "",

      //           rules: [{ required: true, message: "请输入密码" }]
      //         })(
      //           <Input
      //             prefix={
      //               <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
      //             }
      //             type="password"
      //             placeholder="请输入密码"
      //           />
      //         )}
      //       </Form.Item>

      //       <Form.Item>
      //         <Button
      //           style={{ width: "100%", height: 50, marginTop: 10, width: 400 }}
      //           type="primary"
      //           htmlType="submit"
      //         >
      //           登录
      //         </Button>
      //       </Form.Item>
      //     </Form>
      //   </div>
      //   <div className="loginFooter">Copyright@2019上海奕优科技有限公司</div>
      // </div>
    );
  }
}

export default Form.create()(Login);
